import { styled } from '@mui/material';
import './index.scss';

import { Text } from '../../shared/uiComponents';
import { BACKGROUND } from '../../shared/Helpers/colors';
import { AdminTypes } from '../../components/Menu';
import { Loader } from '../../components/StyledComponents';
import BCBA from './BCBA';
import Admin from './Admin';
import ClinicalSupervisor from './CS';
// import DesignInfo from "./DesignInfo";

import { useSelector } from '../../redux/store';

export const Containerr = styled('div')(() => ({
	backgroundColor: BACKGROUND.PRIMARY[100],
	width: '100%',
	padding: '24px',
	borderRadius: '12px',
	minWidth: '720px',
	maxWidth: '1440px',
	display: 'flex',
	alignItems: 'center',
	flexDirection: 'column',
	'>div': {
		width: 'max-content',
	},
	'@media (max-width: 768px)': {
		minWidth: '220px',
		padding: '8px',
	},
}));

const Dashboard = () => {
	const loadingAccount = useSelector((state) => state.account.loading);
	const role = useSelector((state) => state.account.role);

	return (
		<>
			{/* <DesignInfo /> */}
			<Text title="Welcome" type="h2" font="header" fontWeight="semiBold" className="marginBottom16" />
			{AdminTypes.admin === role?.section.id && <Admin />}
			{/* eslint-disable-next-line react/jsx-pascal-case */}
			{AdminTypes.bcba === role?.section.id && <BCBA />}
			{AdminTypes.cs === role?.section.id && <ClinicalSupervisor />}
			{loadingAccount && <Loader />}
		</>
	);
};

export default Dashboard;
